





















import Vue from 'vue'
import Component from 'vue-class-component'

@Component<JobDetailsViewDebugInfo>({
  props: {
    jobPosting: Object
  },
})

export default class JobDetailsViewDebugInfo extends Vue {
  /**
   * Props variables
   */


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
